import localForage from "localforage";

export async function logout () {
    await localForage.removeItem("marier.user-token");
}

export default logout;
